/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_GInputs */

const en_tut_tampilan_g = /** @type {(inputs: Tut_Tampilan_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small things that decide whether people are comfortable using this eight hours a day.`)
};

const id_tut_tampilan_g = /** @type {(inputs: Tut_Tampilan_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hal kecil yang membuat orang betah memakainya delapan jam sehari.`)
};

/**
* | output |
* | --- |
* | "Small things that decide whether people are comfortable using this eight hours a day." |
*
* @param {Tut_Tampilan_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_g = /** @type {((inputs?: Tut_Tampilan_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_g(inputs)
	return en_tut_tampilan_g(inputs)
});